<template>
    <div class="content">
        <h4>联系我们</h4>
        <br/>  <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            合作:ixfind@qq.com
        </p>
        <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            反馈:ixfind@126.com
        </p>
    </div>
</template>

<script>
    export default {
        name: 'ContactContent',
    }
</script>
<style scoped>
.content{
    color: gray;
}
</style>